import { UntitledIcon } from '@faceup/icons'
import { ulLinkBroken02 } from '@faceup/icons/ulLinkBroken02'
import { Typography } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { CircleIcon } from './CircleIcon'
import { PageTitle } from './PageTitle'

type UnavailableNoticeProps = {
  title: ReactNode
  description: ReactNode
  action?: ReactNode
}

/**
 * Layout only - each surface brings its own copy and its own centering. Keeping the
 * wording out of here is what stops the screens drifting apart on a design change.
 */
export const UnavailableNotice = ({ title, description, action }: UnavailableNoticeProps) => (
  <div className='flex max-w-[480px] flex-col items-center gap-6 px-6'>
    <CircleIcon icon={<UntitledIcon icon={ulLinkBroken02} size='28px' />} color='error' />
    <PageTitle
      description={
        <span className='mx-auto block max-w-xs'>
          <Typography.Text type='secondary'>{description}</Typography.Text>
        </span>
      }
    >
      {title}
    </PageTitle>
    {action}
  </div>
)
